// @ts-nocheck

import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';

import { Target } from '../../client';

const browsersAnimationEndEvent = ['webkitAnimationEnd', 'mozAnimationEnd', 'animationend'];

const AnimateOnChange = ({ transition = 'increasing', children }) => {
  const [animate, setAnimate] = useState(false);
  const nodeElement = useRef(null);
  const initialRender = useRef(true);

  useEffect(() => {
    const node = nodeElement.current;
    const onAnimationEnd = () => setAnimate(false);
    browsersAnimationEndEvent.forEach((event) => {
      node.addEventListener(event, onAnimationEnd);
    });
    return () => {
      browsersAnimationEndEvent.forEach((event) => {
        node.removeEventListener(event, onAnimationEnd);
      });
    };
  }, []);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      setAnimate(true);
    }
  }, [children]);

  return (
    <span ref={nodeElement} className={animate ? transition : ''}>
      {children}
    </span>
  );
};

if (Target.__ENV__ !== 'production') {
  AnimateOnChange.propTypes = {
    transition: PropTypes.string,
    children: PropTypes.node.isRequired,
  };
}

export default React.memo(AnimateOnChange);
